// Components
import AdvanceGeneratorApp from "./AdviceGeneratorApp";

const App = () => {
	return (
		<div>
			<AdvanceGeneratorApp />
		</div>
	);
};

export default App;
